import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import type { Scope as SentryScope } from '@sentry/react';
import App from './App';
import './config/sentry';

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<Sentry.ErrorBoundary
			beforeCapture={(scope: SentryScope) => {
				scope.setTag('issue_type', 'CODE_BASE');
				return scope;
			}}
			fallback={<p>Something went wrong.</p>}
		>
			<App />
		</Sentry.ErrorBoundary>
	</StrictMode>,
);
